<div *ngIf="canEdit || !educationSection.empty" class="bulb-education-section">
  <div class="drag-line" pDroppable="section" (onDrop)="drop($event, educationSection)"></div>
  <span [ngClass]="{'show-handle': !editMode && canEdit}" pDraggable="section" (onDragStart)="dragStart($event, educationSection)" class="resume-drag-handle">
    <svg-icon
      [key]="'grip-lines-solid'"
      fontSize="1.5rem"
  >
  </svg-icon>
  </span>
  <bulb-resume-section *transloco="let t; read: 'resume.education'" sectionName="{{ 'resume.education.section' | transloco }}"
             [resumeSection]="educationSection"
             [resumeComponent]="resumeComponent"
             [(open)]="isTabOpen"
             (onEdit)="beginEdit()"
             [showEditIcon]="!editMode && canEdit"
             [showDeleteIcon]="canEdit && !editMode"
             [canEdit]="canEdit"
             (onNewEntry)="addEntry()"
             [showAddEntryButton]="showAddEntryButton"
             (onClose)="handleTabClose()"
             (onOpen)="handleTabOpen()"
             pDraggable="section"
             pDroppable="section"
             (onDrop)="drop($event, educationSection)"
             (onDragStart)="dragStart($event, educationSection)"
             [pDraggableDisabled]="isTabOpen">
    <div sectionContent>
      <bulb-resume-sub-section *ngFor="let subsection of educationSubSectionClone; let subSectionIndex = index"
                   [editMode]="subsection.editMode"
                   [units]="subsection.portfolioContent"
                   [resumeComponent]="resumeComponent"
                   [allowSubSectionDelete]="false"
                   [resumeSection]="educationSection">
        <aero-form subSectionEdit
               submitButtonLabel="{{ 'saveButton' | transloco }}"
               [showCancelButton]="true"
               (onCancel)="cancelEdit(subSectionIndex)"
               (onSubmit)="save($event, subSectionIndex)">
          <div class="bulb-centered-content">
            <bulb-resume-sub-section-logo
              *ngIf="subsection.editMode"
              [logoUrl]="subsection.logoUrl || subsection.logo?.url"
              [altText]="subsection.schoolName"
              (uploadComplete)="onUploadComplete($event)"
              (delete)="deleteLogo(subSectionIndex)">
            </bulb-resume-sub-section-logo>
            <div class="row">
              <div class="columns medium-12">
                <aero-input label="{{ 'resume.education.schoolName' | transloco }}"
                      [(ngModel)]="subsection.schoolName"
                      [id]="'educationSchoolName-'+ subSectionIndex"
                      [name]="'schoolName'"
                      [required]="true"
                      maxlength="120">
                </aero-input>
                <aero-input label="{{ 'resume.education.degreeEarned' | transloco }}"
                            [(ngModel)]="subsection.degree"
                            [id]="'educationDegree-'+ subSectionIndex"
                            [name]="'degree'"
                            [maxlength]="120">
                </aero-input>
              </div>
              <div class="columns medium-12">
                <div class="p-field-checkbox">
                  <p-checkbox [(ngModel)]="subsection.current"
                              (ngModelChange)="resetEndDate($event, subSectionIndex)" name="current"
                              [inputId]="'bulbResumeEducationCurrentProgram-' + subSectionIndex" [binary]="true">
                  </p-checkbox>
                  <label [for]="'bulbResumeEducationCurrentProgram-' + subSectionIndex">
                    {{ t('currentProgram') }}
                  </label>
                </div>
              </div>
              <div class="columns medium-6">
                <aero-calendar-picker label="{{ 'resume.startDate' | transloco }}"
                            [(ngModel)]="subsection.educationStartDate"
                            [name]="'educationStartDate'"
                            [inputId]="'bulbEducationStartDate' + subSectionIndex"
                            [dateFormat]="'mm/yy'"
                            [hintMessage]="'MM/YYYY'"
                            [pickerView]="'month'"
                            errorMessage="{{ 'resume.invalidDate' | transloco }}"
                            [minDate]="datepickerConfig.minDate"
                            [maxDate]="datepickerConfig.maxDate"
                            [yearRange]="datepickerConfig.range">
                </aero-calendar-picker>
              </div>
              <div class="columns medium-6">
                <aero-calendar-picker label="{{ 'resume.endDate' | transloco }}"
                            [(ngModel)]="subsection.educationEndDate"
                            [name]="'educationEndDate'"
                            [inputId]="'bulbEducationEndDate' + subSectionIndex"
                            [dateFormat]="'mm/yy'"
                            [hintMessage]="'MM/YYYY'"
                            [pickerView]="'month'"
                            errorMessage="{{ 'resume.invalidDate' | transloco }}"
                            [minDate]="datepickerConfig.minDate"
                            [maxDate]="datepickerConfig.maxDate"
                            [yearRange]="datepickerConfig.range"
                            [disabled]="subsection.current"
									          [placeholder]="subsection.endDatePlaceholder">
                </aero-calendar-picker>
              </div>
              <div class="text-center bulb-resume-add-btn">
                <aero-button [aeroStyle]="addPortfolioContentButtonStyle"
                       icon="fal fa-plus"
                       label="{{ 'resume.add.portfolioContent' | transloco }}"
                       (onClick)="addPortfolioContent(subSectionIndex)">
                </aero-button>
              </div>
              <!-- Show the selected portfolio content : -->
              <bulb-resume-content-selection-display
                [aeroFormComponent]="aeroFormComponentList.toArray()[subSectionIndex]"
                [resumeSubSection]="this"
                [editMode]="subsection.editMode"
                [units]="subsection.portfolioContent"
                [renderResumeSubSectionTileView]="true"
                (onUnitRemoved)="onPortfolioContentRemoved($event, subSectionIndex)">
              </bulb-resume-content-selection-display>
            </div>
          </div>
        </aero-form>
        <div class="education-view" subSectionView>
          <div class="education-subsection">
            <div class="row">
              <div [ngClass]="{'columns small-1': isLogoUploaded}">
                <div *ngIf="subsection.logo?.url" class="bulb-resume-section-logo-image-view">
                  <img [src]="subsection.logo?.url" [alt]="subsection.schoolName">
                </div>
              </div>
              <div class="columns small-11 padding-left">
                <div class="education-schoolname">{{subsection.schoolName}}</div>
                <div class="education-degree-year">
                  {{subsection.degree}}
                  <span *ngIf="subsection.degree && (subsection.educationStartDate
                     || subsection.educationEndDate)">|</span>
                  <span *ngIf="subsection.educationStartDate || subsection.educationEndDate">
                    {{subsection.educationStartDate | date:'yyyy'}} -
                    <span *ngIf="subsection.current; else endDate">{{this.endDatePlaceholder}}</span>
                    <ng-template #endDate>
                      {{subsection.educationEndDate | date:'yyyy'}}
                    </ng-template>
                  </span>
                </div>
                <div *ngIf="canEdit" class="bulb-view-section-buttons">
                  <div class="edit-entry-button">
                    <aero-button [aeroStyle]="editAndDeleteButtonStyle"
                                 icon="far fa-pencil"
                                 labelCode="button_edit"
                                 (onClick)="beginEdit(subSectionIndex)">
                    </aero-button>
                  </div>
                  <div class="delete-entry-button">
                    <aero-button [aeroStyle]="editAndDeleteButtonStyle"
                                 icon="fal fa-trash-alt"
                                 (onClick)="deleteEntry($event, subSectionIndex)"
                                 labelCode="button_delete">
                    </aero-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </bulb-resume-sub-section>
    </div>
  </bulb-resume-section>
</div>
